// import React from "react";
import styles from "./Hero.module.scss";
import Image from "next/image";
import { Trans, useTranslation } from "next-i18next";
import { NextSeo } from "next-seo";
import Background from "@cs/public/img/about/background.jpg"
import BackgroundMobile from "@cs/public/img/about/background_mobile.jpg"
import { useDeviceSize } from "@climate-science/component-library";

export const Hero = () => {
  const {t} = useTranslation('about')
  const {
    isMobile,
    isSmallMobile
  } = useDeviceSize()

  return (
    <header className={styles.outerHero}>
      <NextSeo 
        title={t("meet-team")}
      />
      <Image 
        src={
          isMobile || isSmallMobile
            ? BackgroundMobile
            : Background
        }
        className={styles.bgImage}
        alt=''
        objectFit='cover'
        layout='fill'
        objectPosition={
          isMobile || isSmallMobile
            ? 'center'
            : 'left'
        }
      />
      <div className={styles.blueLayer}/>
      <div className={styles.front}>
        <h1 className={styles.title}>
          <Trans
            t={t}
            i18nKey={'hero.title'}
          />
        </h1>
        <p className={styles.description}>
          {t('hero.description')}
        </p>
      </div>
    </header>
  )}